<template>

  <ModalContainer queryParam="f006" ref="modalContainer" size="lg">

    <b-alert v-if="messageAlert" show :variant="messageAlert.variant" class="p-2 text-center">
      {{ messageAlert.text }}
    </b-alert>

    <b-card>

      <div>

        <h4 class="text-primary text-center mb-2">EPICRISIS</h4>

     <div class="mb-1 row p-1" v-if="dataProceso">
          <div class="col"><b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
          <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
        </div>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-success"
          active-tab-class="font-weight-bold text-success">
          <b-tab title="Resumenes / Hallazgos" active>
            <b-card>
              <b-row>

                 <b-col cols="12" class="my-1">
                  <label>Resumen del cuadro clinico:</label>
                  <b-form-textarea v-model="epicrisis.resumenCuadroClinico" />
                </b-col>

                <b-col cols="12" class="my-1">
                  <label>Resumen de evolucion y complicaciones:</label>
                  <b-form-textarea v-model="epicrisis.resumenEvolucion" />
                </b-col>

                <b-col cols="12" class="my-1">
                  <label>
                    Hallazgos relevantes de examenes y procedimientos, diag:
                  </label>
                  <b-form-textarea v-model="epicrisis.hallazgosRelevantes" />
                </b-col>

                <b-col cols="12" class="my-1">
                  <label>
                    Resumen de tratamiento y procedimientos terapeuticos:
                  </label>
                  <b-form-textarea v-model="epicrisis.resumenTratamiento" />
                </b-col>

                <b-col cols="8" class="my-1">
                  <label>Indicaciones de alta/egreso:</label>
                  <b-form-textarea v-model="epicrisis.indicacionesAlta" />
                </b-col>
                
                <b-col cols="4" class="my-1">
                  <label>Proximo control:</label>
                  <b-form-textarea v-model="epicrisis.proximoControl" />
                </b-col>

              </b-row>

            </b-card>
          </b-tab>



          <b-tab title="Diagnosticos">
            <b-card>
              <b-row>
                <b-col cols="12" class="my-1">

                  <label>
                    <b>Diagnostico(s) de alta/egreso: </b>
                    <span v-if="epicrisis.principal" class="text-primary parpadeo">
                      (Ingrese el principal)
                    </span>
                    <span v-else class="text-warning">
                      (Ingrese el/los secundario(s))
                    </span>
                  </label>

                  <b-row class="d-flex align-items-center">

                    <SearchOpts v-model="searchDiagnostico" :searchService="diagnosticosService.getByQuerySelect"
                      :minChars="3" :placeholder="'Buscar diagnostico...'" class="col-8" />

                    <b-form-checkbox switch class="col-2" disabled v-model="epicrisis.principal">
                      Principal
                    </b-form-checkbox>

                    <b-col cols="2">
                      <b-button variant="warning" @click="agregarDiagnostico" size="sm">
                        <i class="fa-solid fa-plus" />
                      </b-button>
                    </b-col>

                    <b-col v-if="epicrisis.diagnosticosList" class="mt-1" cols="12">
                      <b-table small :items="epicrisis.diagnosticosList" :fields="fields">
                        <template #cell(principal)="data">
                          {{ data.item.principal ? "SI" : "NO" }}
                        </template>
                        <template #cell(acciones)="data">
                          <b-button @click="eliminarRegistro(data.index)" variant="danger" size="sm">
                            <i class="fa-solid fa-trash"></i>
                          </b-button>
                         
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>

                  <b-row class="mt-1">
                    <b-col cols="12">
                      <label><b> Causa Externa</b></label>
                      <b-form-input v-model="epicrisis.causaExterna" />
                    </b-col>
                  </b-row>

                </b-col>
              </b-row>
            </b-card>
          </b-tab>


          <b-tab title="Condicion/Medicos">
            <b-card>

              <b-row class="mb-1">
                <label class="mr-1">Condicion de Alta/Egreso: </label>
                <b-form-radio-group v-model="epicrisis.vivoMuerto" :options="optsVivoMuerto" />
              </b-row>


              <b-row>
                <label>Seleccione:</label>
              </b-row>

              <b-row>
                <b-form-radio-group class="col-6" v-model="epicrisis.selectedCondicion" :options="optsCondiciones"
                  stacked />

                <b-form-radio-group class="col-6" v-model="epicrisis.selectedTipoAlta" :options="optTipoAlta" stacked />
              </b-row>

              <b-row class="mt-2">
                <b-form-radio-group class="col-6" v-model="epicrisis.selectedDefuncion" :options="optDefuncion"
                  stacked />

                <b-col cols="3">
                  <label>Dias de reposo:</label>
                  <b-form-input type="number" v-model="epicrisis.diasReposo" />
                </b-col>

                <b-col cols="3">
                  <label>Dias de estadia:</label>
                  <b-form-input type="number" v-model="epicrisis.diasEstadia" />
                </b-col>
              </b-row>

              <b-row>                
                <label>Observaciones:</label>
                <b-form-textarea v-model="epicrisis.obsCondicion" />
              </b-row>
              <div class="row mt-1">
                <label>Seleccione la hora de alta:</label>
                 <vue-timepicker class="col-12 mt-1" v-model="epicrisis.objectHoraAlta" fixed-dropdown-button format="HH:mm" manual-input/>  
              </div>

            </b-card>


            <b-card >
              <b-row class="d-flex align-items-end">

                <div class="col-9">

                  <label>Medicos Tratantes</label>
                  <SearchOpts v-model="doctor" :searchService="doctoresService.searchDoctoresByTermSelect" :minChars="3"
                    :placeholder="'Buscar doctor...'" />
                </div>
                 <div class="col-2">
                  <label>Es responsable?</label>
                  <b-form-checkbox  switch v-model="responsable" >{{ responsable ? "SI" : "NO" }}</b-form-checkbox>
                </div>


                <div class="col-3">
                  <label>Fecha</label>

                  <flat-pickr size="sm" class="form-control" v-model="fechaActual" locale="es"
                    :config="birthDateConfig" />
                </div>

                <div class="col-2">
                  <b-button title="Agregar a tabla" size="sm" variant="info" @click="agregarMedico">
                    <i class="fa-solid fa-plus" />
                  </b-button>
                </div>

               
              </b-row>


              <b-row>
                <b-table v-if="epicrisis.medicosList" class="mt-2 col-12" small :items="epicrisis.medicosList"
                  :fields="fieldsMedicos">

                  <template #cell(acciones)="data">
                    <b-button @click="eliminarMedico(data.index)" variant="danger" size="sm" title="Eliminar registro">
                      <i class="fa-solid fa-trash" />
                    </b-button>
                  </template>
                  <template #cell(doctor)="data">
                    {{ data.item.doctor.text }}
                  </template>
                   <template #cell(responsable)="data">
                    {{ data.item.responsable ? "SI" : "NO" }}
                  </template>
                </b-table>
              </b-row>
            </b-card>
          </b-tab>
        </b-tabs>
      </div>

      <div class="text-right">
        <b-button variant="primary" class="mr-2" @click="onSaveEpicrisi">
          Guardar
        </b-button>

        <b-button>
          Cancelar
        </b-button>

      </div>
    </b-card>

  </ModalContainer>

</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import { SearchOpts, ModalContainer } from "@/shared/components";
import { doctoresService, auxiliarService } from "@/shared/services";
import { diagnosticosService } from "../../../atencionMedica/services";
import { procedimientosFormulariosService, procedimientosService } from "../../services";
import { getDataForms } from "../../helpers/getDataForms";

export default {
  components: {
    flatPickr,
    SearchOpts,
    ModalContainer,
    VueTimepicker
  },

    props:{
    dataProceso:{
      default:null,
      required:false
    }
  },

  data() {
    return {
      responsableExist : false,
      
      idRegistroForm: null,

      messageAlert: null,
      procedimientosService,

      epicrisis: {
        resumenEvolucion: "",
        hallazgosRelevantes: "",
        resumenTratamiento: "",
        indicacionesAlta: "",
        resumenCuadroClinico: "",
        diagnosticosList: [],
        causaExterna: "",

        vivoMuerto: "1",
        medicosList: [],
        principal: true,
        selectedCondicion: null,
        selectedTipoAlta: null,
        selectedDefuncion: null,
        diasReposo: '',
        diasEstadia: '',
        obsCondicion: '',
        proximoControl: '',
        horaAlta:'',
        objectHoraAlta:null,
      },

      optTipoAlta: [
        { value: "1", text: "Alta Médica" },
        { value: "2", text: "Alta Voluntaria" }
      ],

      optDefuncion: [
        { value: "1", text: "Defuncion menos de 48 horas" },
        { value: "2", text: "Defuncion mas de 48 horas" }
      ],

      optsCondiciones: [
        { value: "1", text: "Asintomatico" },
        { value: "2", text: "Discapacidad" },
        { value: "3", text: "Retiro no autorizado" },
      ],

      optsVivoMuerto: [
        { value: "1", text: "Vivo" },
        { value: "2", text: "Fallecido" },
      ],

      searchDiagnostico: null,
      diagnosticosService,
      idProcActual: null,
      doctoresService,
      auxiliarService,
      periodo: null,
      notasEvolucion: null,
      farmacoterapia: null,
      doctor: null,
      auxiliar: null,
      dispositivo: null,
      profesional: null,
      fechaActual: null,
      horaActual: null,

      birthDateConfig: {
        allowInput: true,
        dateFormat: "Y-m-d", // Solo fecha
      },
      procedimiento: [],
      itemsTabla: [],
      responsable:false,
      fields: [
        {
          key: "diagnostico",
          label: "Diagnostico",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "principal",
          label: "principal",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],

      fieldsMedicos: [

        {
          key: "doctor",
          label: "doctor",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },

        {
          key: "especialidad",
          label: "especialidad",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "periodo",
          label: "periodo",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "responsable",
          label: "responsable",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],
    };
  },
  created() {

    this.setDate();
    this.loadData();

    //if (this.jsoFormEpicrisis) {
    //  this.epicrisis = this.jsoFormEpicrisis
    //}

  },

  methods: {

    async loadData() {
       this.epicrisis= {
        resumenEvolucion: "",
        hallazgosRelevantes: "",
        resumenTratamiento: "",
        indicacionesAlta: "",

        diagnosticosList: [],
        causaExterna: "",

        vivoMuerto: "1",
        medicosList: [],
        principal: true,
        selectedCondicion: null,
        selectedTipoAlta: null,
        selectedDefuncion: null,
        diasReposo: '',
        diasEstadia: '',
        obsCondicion: '',
        proximoControl: '',
        horaAlta:'',
        objectHoraAlta:null,
      }
     
      this.idRegistroForm = null;

      this.tokenProceso = this.$route.query.forms
      const tokenFormulario = this.$route.query.f006;

      const atencion = await procedimientosService.getDataAtencionByTokenProc(this.tokenProceso)

        if (atencion && atencion.cuadroClinico) {   
          this.epicrisis.resumenCuadroClinico = atencion.cuadroClinico               

        }

      const responseGet = await procedimientosFormulariosService.obtenerFormProcDataByToken(tokenFormulario);

      console.log("response get", responseGet)



      if (responseGet) {
        this.messageAlert = {
          variant: "success",
          text: "Se encontró información registrada, se procederá a actualizar"
        }

      } else {
        this.messageAlert = {
          variant: "warning",
          text: "No se encontró informacion registrada"
        }
        return;
      }

   

      try {
        const epicrisis = JSON.parse(responseGet.dataJson)
        this.epicrisis = epicrisis
        
      } catch (error) { console.log("error", error) }


      
      this.idRegistroForm = responseGet.id;

    },

    setDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      const day = String(now.getDate()).padStart(2, "0");
      this.fechaActual = `${year}-${month}-${day}`;
      this.horaActual = now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2);
    },


    eliminarRegistro(index) {
      this.epicrisis.diagnosticosList.splice(index, 1);
      const dataTable = this.epicrisis.diagnosticosList;
      const hayPrincipal = [];

      dataTable.forEach((data) => {
        if (data.principal) hayPrincipal.append(data.principal);
      });

      if (hayPrincipal.length === 0) {
        this.epicrisis.principal = true;
      }
    },

eliminarMedico(index) {
  this.epicrisis.medicosList.splice(index, 1);
},



    agregarDiagnostico() {
      console.log("click agregar")
      const dataTable = this.epicrisis.diagnosticosList;
      console.log("data table", dataTable)
      if (dataTable && dataTable.length > 5) {
        this.$swal.fire({
          icon: "info",
          text: "No puede agregar mas de 6 diagnosticos",
        });
        return;
      }

      dataTable.forEach((data) => {
        this.epicrisis.principal = data.principal
          ? false
          : this.epicrisis.principal;
      });

      this.epicrisis.diagnosticosList.push({
        diagnostico: this.searchDiagnostico.text,
        diagObject: this.searchDiagnostico,
        principal: this.epicrisis.principal,
      });
      this.searchDiagnostico = null;
      this.epicrisis.principal = false;
    },



    agregarMedico() {

      if (!this.doctor || !this.fechaActual) {
        const falta = this.doctor ? "fecha" : "doctor"
        this.$swal.fire({
          icon: "warning",
          text: `Falta de completar el campo: ${falta}`
        })
        return
      }
      const tableMedicos = this.epicrisis.medicosList || []
      let respExistente = false
      let docExistente = false

    
      tableMedicos.forEach(element => {
        
        if (element.doctor.id === this.doctor.id){
          this.$swal.fire({
          icon: "warning",
          text: `Medico ya existente. Ingrese otro.`
        })
          docExistente = true
        }
        if (element.responsable && this.responsable) {       
        this.$swal.fire({
          icon: "warning",
          text: `Solo puede definir 1 medico responsable. Gracias.`
        })
        respExistente = true        
        }
      })
      if (docExistente) { return}
      if (respExistente) { return }

      this.epicrisis.medicosList.push({
        doctor: this.doctor,
        especialidad: this.doctor.especialidad,
        periodo: this.fechaActual,
        responsable: this.responsable
      });
      this.doctor = null;
    },


    async onSaveEpicrisi() {
      const dataTable = this.epicrisis.diagnosticosList;
      console.log("data table", dataTable)
      if (!dataTable || dataTable.length < 1) {
        this.$swal.fire({
          icon: "info",
          text: "Debe agregar un diagnostico al menos"})
        return;
      }


      const params = {
        nameForm: "006",
        dataJson: JSON.stringify(this.epicrisis),
        tokenProceso: this.tokenProceso,
        idRegistroForm: this.idRegistroForm
      };

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });

       this.$emit("formulario-guardado");

       await this.$router.push({ query: { ...this.$route.query, f006: undefined } });
       


    },
  },

  watch: {
   

    '$route.query.f006': {
      handler(newValue) {
        if (newValue) { this.loadData() }

      },
    },
     'epicrisis.objectHoraAlta': {
      handler(newValue) {
        if (newValue) {
          try{
            
            this.epicrisis.horaAlta = `${newValue.HH}:${newValue.mm}`
            console.log('esta es la hora alta', this.epicrisis.horaAlta)
          }
          catch(error){console.log(error)}
         }

      },
    },
  }

};
</script>

<style scoped>
.flatpickr-input {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.parpadeo {
  font-weight: 200;
}
</style>
